import IdentityVerification from "@component/IdentityVerification/IdentityVerification";

function VerifyIdentity() {
  return <IdentityVerification />;
}

export default VerifyIdentity;
